export default __webpack_public_path__ + "static/media/mongodb.f5f9d321.png";